<div style="padding: 20px 22px; max-height: 90vh; display: flex; flex-direction: column; min-width: 420px;">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 10px; border-bottom: 1px solid #e5e7eb; padding-bottom: 14px; margin-bottom: 14px;">
    <mat-icon style="color: #1C593D;">badge</mat-icon>
    <div style="flex: 1;">
      <h2 style="font-size: 1.05rem; font-weight: 800; color: #1e5a3f; margin: 0;">
        Detalle del beneficiario
      </h2>
      <p style="font-size: 0.74rem; color: #6b7280; margin: 2px 0 0;">
        Validá la información antes de usarlo.
      </p>
    </div>
    <span *ngIf="b.vitaEstado === 'ok'"
      style="background: #dcfce7; color: #166534; font-size: 0.62rem; font-weight: 700; padding: 3px 8px; border-radius: 999px;">
      VALIDADO
    </span>
    <span *ngIf="b.vitaEstado === 'banned'"
      style="background: #fee2e2; color: #991b1b; font-size: 0.62rem; font-weight: 700; padding: 3px 8px; border-radius: 999px;">
      NO HABILITADO
    </span>
    <button type="button" (click)="close()"
      style="background: transparent; border: none; cursor: pointer; color: #6b7280; padding: 4px; margin-left: 4px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div style="flex: 1; overflow-y: auto; padding-right: 4px;">

    <!-- Aviso (no habilitado / faltan datos), resuelto por quien abre la ficha -->
    <div *ngIf="data.aviso"
      style="display: flex; align-items: flex-start; gap: 8px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px; padding: 11px 13px; margin-bottom: 14px; color: #92400e; font-size: 0.82rem;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0;">info_outline</mat-icon>
      <span>{{ data.aviso }}</span>
    </div>

    <div style="font-size: 1.15rem; font-weight: 800; color: #111827;">
      {{ fullName }}
    </div>
    <div style="font-size: 0.78rem; color: #6b7280; margin-top: 2px;">
      {{ b.varianteLabel }}
    </div>

    <!-- Bloque identidad -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px 14px; margin-top: 14px;">
      <div style="font-size: 0.7rem; text-transform: uppercase; font-weight: 700; color: #6b7280; letter-spacing: 0.04em; margin-bottom: 8px;">
        Identidad
      </div>
      <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 6px; column-gap: 14px; font-size: 0.82rem;">
        <div><span style="color: #6b7280;">Documento:</span> <b>{{ b.tipoId }} {{ b.numeroId }}</b></div>
        <div><span style="color: #6b7280;">País:</span> <b>{{ b.paisCodigo }}</b></div>
        <div *ngIf="b.email"><span style="color: #6b7280;">Email:</span> <b>{{ b.email }}</b></div>
        <div *ngIf="b.telefono"><span style="color: #6b7280;">Teléfono:</span> <b>{{ b.telefono }}</b></div>
      </div>
    </div>

    <!-- Bloque bancario -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px 14px; margin-top: 10px;">
      <div style="font-size: 0.7rem; text-transform: uppercase; font-weight: 700; color: #6b7280; letter-spacing: 0.04em; margin-bottom: 8px;">
        Datos bancarios
      </div>
      <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 6px; column-gap: 14px; font-size: 0.82rem;">
        <div><span style="color: #6b7280;">Banco:</span> <b>{{ b.bancoNombre || '—' }}</b></div>
        <div><span style="color: #6b7280;">Cuenta:</span> <b>{{ b.cuentaMask || '—' }}</b></div>
        <div *ngFor="let item of datosBancariosEntries">
          <span style="color: #6b7280;">{{ labelFor(item.key) }}:</span>
          <b> {{ item.value }}</b>
        </div>
      </div>
    </div>

    <!-- Bloque de verificación -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 12px 14px; margin-top: 10px;">
      <div style="font-size: 0.7rem; text-transform: uppercase; font-weight: 700; color: #6b7280; letter-spacing: 0.04em; margin-bottom: 8px;">
        Estado de verificación
      </div>
      <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 6px; column-gap: 14px; font-size: 0.82rem;">
        <div><span style="color: #6b7280;">Variante:</span> <b>{{ b.variante }}</b></div>
        <div *ngIf="b.vitaChequeadoAt">
          <span style="color: #6b7280;">Último chequeo:</span>
          <b> {{ b.vitaChequeadoAt | date:'dd/MM/yyyy HH:mm' }}</b>
        </div>
        <div><span style="color: #6b7280;">Registrado:</span> <b>{{ b.createdAt | date:'dd/MM/yyyy' }}</b></div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div style="display: flex; gap: 8px; border-top: 1px solid #e5e7eb; padding-top: 14px; margin-top: 14px;">
    <button type="button" (click)="close()" [style.flex]="data.hideUse ? '1' : 'none'"
      style="padding: 10px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;">
      Cerrar
    </button>
    <button type="button" (click)="use()"
      *ngIf="!data.hideUse"
      [disabled]="b.vitaEstado === 'banned'"
      [style.opacity]="b.vitaEstado === 'banned' ? '0.5' : '1'"
      [style.cursor]="b.vitaEstado === 'banned' ? 'not-allowed' : 'pointer'"
      style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
      Usar este beneficiario
    </button>
  </div>
</div>
